import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"width":"392px"}
}
const _hoisted_2 = { class: "overlay-wrapper card-rounded min-h-225px overflow-hidden h-275px border border-1" }
const _hoisted_3 = { class: "w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200" }
const _hoisted_4 = {
  key: 0,
  class: "w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200"
}
const _hoisted_5 = {
  key: 1,
  class: "text-black-50 opacity-80 fs-1"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark card-rounded bg-opacity-25" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
], -1)

import { inject, ref } from "vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { userDocumentsInjectionKeys } from "./UserDocumentsInjectionKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'KycDocuments',
  setup(__props) {

const finalizeKyc = inject(
  userDocumentsInjectionKeys.finalizeKyc,
  ref<any>({})
);
const kycLoading = inject(userDocumentsInjectionKeys.kycLoading, ref(false));
const showFinalizedKyc = inject(
  userDocumentsInjectionKeys.showFinalizedKyc,
  async () => undefined
);

return (_ctx: any,_cache: any) => {
  return (Object.keys(_unref(finalizeKyc)).length != 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          class: "d-block overlay mb-4",
          "data-fslightbox": "lightbox-hot-sales",
          href: "#",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(showFinalizedKyc) && _unref(showFinalizedKyc)(...args)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_unref(kycLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(ScaleLoader, { color: '#ffc730' })
                  ]))
                : (_openBlock(), _createElementBlock("h1", _hoisted_5, "KYC Form"))
            ])
          ]),
          _hoisted_6
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})